export default __webpack_public_path__ + "static/media/katalog-eng.cc6790ae.png";